import React, { useRef } from 'react'
import styled from '@mui/material/styles/styled'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import PrimaryButton from 'core-system/Button/PrimaryButton'
import { MyCommuters as MyCommutersIcon } from 'core-system/Icons/Sidebar'
import { Add as AddIcon } from 'core-system/Icons/Actions'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Tabs from 'core-system/Tabs/Tabs'
import DropdownMenu from 'core-system/Dropdown-menu/DropdownMenu'
import ConnectHris from './ConnectHris'
import Tooltip from '@mui/material/Tooltip'
import SegmentOperations from '../worksites/SegmentOperations'

const TopButtons = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: '1rem',
  marginBottom: '2rem',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}))

interface PageHeaderProps {
  createNewGroupWorksite?: () => void
  onInviteCommutersClick?: () => void
  inviteCommutersCSV?: () => void
  hrisStatus?: any
  activeTab: number
  setActiveTab: (tab: number) => void
  tabs: { label: string; value: number }[]
  newGroupWorksiteButtonText?: string
  showCreateNewGroupButton?: boolean
  showAddCommutersButton?: boolean
  showInviteCommutersButton?: boolean
  inviteCommutersCSVDisabled?: boolean
  inviteCommutersCSVTooltip?: string
  rightComponent?: React.ReactNode
  newGroupWorksiteButtonTooltip?: string
  isCreateNewGroupWorksiteDisabled?: boolean
}

const PageHeader = ({
  createNewGroupWorksite,
  onInviteCommutersClick,
  inviteCommutersCSV,
  inviteCommutersCSVDisabled = false,
  inviteCommutersCSVTooltip,
  hrisStatus,
  activeTab,
  setActiveTab,
  tabs,
  newGroupWorksiteButtonText = 'Create New Group',
  showCreateNewGroupButton = false,
  showAddCommutersButton = false,
  showInviteCommutersButton = false,
  rightComponent,
  newGroupWorksiteButtonTooltip,
  isCreateNewGroupWorksiteDisabled,
}: PageHeaderProps) => {
  const menuRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <TopButtons>
        {showCreateNewGroupButton && (
          <Tooltip title={newGroupWorksiteButtonTooltip}>
            <span>
              <SecondaryButton
                startIcon={<AddIcon />}
                onClick={createNewGroupWorksite}
                disabled={isCreateNewGroupWorksiteDisabled}
              >
                {newGroupWorksiteButtonText}
              </SecondaryButton>
            </span>
          </Tooltip>
        )}
        {showAddCommutersButton && (
          <SecondaryButton
            startIcon={<MyCommutersIcon />}
            endIcon={<ExpandMoreIcon />}
            ref={menuRef}
          >
            Add Commuters
          </SecondaryButton>
        )}
        {showInviteCommutersButton && (
          <DropdownMenu
            menuItems={[
              {
                element: (
                  <ConnectHris
                    providerName={hrisStatus.providerName}
                    reAuth={hrisStatus.reauth}
                    width='full'
                  />
                ),
                canHover: false,
              },
              {
                element: (
                  <SecondaryButton
                    onClick={inviteCommutersCSV}
                    fullWidth
                    disabled={inviteCommutersCSVDisabled}
                  >
                    Invite Commuter CSV
                  </SecondaryButton>
                ),
                canHover: false,
                tooltip: inviteCommutersCSVTooltip,
              },
            ]}
            anchorRef={menuRef}
            position='bottom'
          />
        )}
        {showInviteCommutersButton && (
          <PrimaryButton
            startIcon={<AddIcon />}
            onClick={onInviteCommutersClick}
          >
            Invite Commuters
          </PrimaryButton>
        )}
      </TopButtons>
      <Tabs
        value={activeTab}
        onChange={(_, value) => {
          setActiveTab(value)
        }}
        aria-label='commuters page tabs'
        tabs={tabs}
        rightComponent={rightComponent || null}
      />
    </>
  )
}

export default React.memo(PageHeader)
